import { useCioPlpContext } from './useCioPlpContext';
import useRequestConfigs from './useRequestConfigs';
export default function useFilter(props) {
    const { facets, sliderStep, facetSliderSteps } = props;
    const contextValue = useCioPlpContext();
    if (!contextValue) {
        throw new Error('useFilter must be used within a component that is a child of <CioPlp />');
    }
    const { getRequestConfigs, setRequestConfigs } = useRequestConfigs();
    const setFilter = (filterName, filterValue) => {
        const newFilters = getRequestConfigs().filters || {};
        newFilters[filterName] = filterValue;
        // Remove filter entirely
        if (filterValue === null) {
            delete newFilters[filterName];
        }
        setRequestConfigs({ filters: newFilters, page: 1 });
    };
    const clearFilters = () => {
        setRequestConfigs({ filters: {}, page: 1 });
    };
    return {
        facets,
        setFilter,
        sliderStep,
        facetSliderSteps,
        clearFilters,
    };
}
